<template>
  <div class="visitorDetail">
    <div v-if="detail !== null && detail.avatar">
      <div class="box">
        <div class="title">被访人信息</div>
        <div class="content">
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">被访人姓名</div>
            <div class="value">{{ detail.acceptName }}</div>
          </div>
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">预约时间</div>
            <div class="value">
              {{
                moment(detail.visitorStartTime).format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </div>
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">审批状态</div>
            <div
              class="status tc"
              :class="detail.auditStatus === 2 ? 'error' : ''"
            >
              {{
                detail.auditStatus === 0
                  ? "待审批"
                  : detail.auditStatus === 1
                  ? "已通过"
                  : "已驳回"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title">拜访人信息</div>
        <div class="content">
          <div class="flex flex-vc">
            <div class="icon">
              <img
                :src="detail.avatar"
                alt=""
                @click="previewImg(detail.avatar)"
              />
            </div>
            <div class="rightContent">
              <div>{{ detail.initiatorName }}</div>
              <span @click.stop="getMobile(detail, detail.isShowMobile)">{{ detail.isShowMobile ? detail.noMobile
      : detail.initiatorPhone }}</span>
              <van-icon class="icon" style="margin-left: 3px;" @click.stop="getMobile(detail, detail.isShowMobile)"
                v-if="!detail.isShowMobile" name="eye-o" />
              <van-icon class="icon" style="margin-left: 3px;" @click.stop="getMobile(detail, detail.isShowMobile)"
                v-if="detail.isShowMobile" name="closed-eye" />
            </div>
          </div>
        </div>
      </div>
      <!-- 核酸检测显示区域 -->
      

      <div class="box">
        <div class="title">其他信息</div>
        <div class="content">
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">所属单位</div>
            <div class="value">
              {{ detail.affiliatedUnit ? detail.affiliatedUnit : "--" }}
            </div>
          </div>
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">车牌号</div>
            <div class="value">
              {{ detail.carNumber ? detail.carNumber : "--" }}
            </div>
          </div>
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">预约事由</div>
            <div class="status tc other" v-if="detail.visitorGoal">
              {{ detail.visitorGoal ? detail.visitorGoal : "--" }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="flex flex-vc flex-b">
            <div class="sonTitle">备注说明</div>
            <div class="desc">{{ detail.remark ? detail.remark : "--" }}</div>
          </div>
        </div>
      </div>
      
      <div class="box" v-show="detail.personnelMessage.length > 1">
        <div class="title">同行人员</div>
        <div class="content">
          <div
            v-for="(item, index) in detail.personnelMessage.slice(1)"
            :key="index"
            class="smallBox flex flex-vc"
          >
            <div class="imgBox">
              <img
                :src="item.photoImg"
                @click="previewImg(item.photoImg)"
                alt=""
              />
            </div>
            <div class="right">
              <div>
                {{ item.visitorName }}
              </div>
              <span @click="getTeacherOrParentMobile(item, item.isShowMobile)">
                {{ item.isShowMobile ? item.noMobile : item.visitorPhone }}
              </span>
              <van-icon class="person-phone" style="margin-left: 3px;"
                @click="getTeacherOrParentMobile(item, item.isShowMobile)"
                v-if="!item.isShowMobile && item.name != '该学生未绑定家长'" name="eye-o" />
              <van-icon class="person-phone" style="margin-left: 3px;"
                @click="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile" name="closed-eye" />

            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="nucleStatus">
        <div class="title">
          <span>预约人及同行人健康码</span>
          <span
            v-if="
              !(
                data.visitorHealthCertificate &&
                data.visitorHealthCertificate.some((x) => x.type == 0)
              )
            "
          >
            : 暂无</span
          >
        </div>
        <div
          class="panel_1"
          v-if="
            data.visitorHealthCertificate &&
            data.visitorHealthCertificate.some((x) => x.type == 0)
          "
        >
          <img
            class="img_1"
            @click="previewImg(img.imgUrl)"
            v-for="img in data.visitorHealthCertificate.filter(
              (x) => x.type == 0
            )"
            :key="img.imgUrl"
            :src="img.imgUrl"
            alt=""
          />
        </div>
        <div class="title">
          <span>预约人及同行人行程码</span>
          <span
            v-if="
              !(
                data.visitorHealthCertificate &&
                data.visitorHealthCertificate.some((x) => x.type == 1)
              )
            "
          >
            : 暂无</span
          >
        </div>
        <div
          class="panel_1"
          v-if="
            data.visitorHealthCertificate &&
            data.visitorHealthCertificate.some((x) => x.type == 1)
          "
        >
          <img
            class="img_1"
            @click="previewImg(img.imgUrl)"
            v-for="img in data.visitorHealthCertificate.filter(
              (x) => x.type == 1
            )"
            :key="img.imgUrl"
            :src="img.imgUrl"
            alt=""
          />
        </div>
        <div class="title">
          <span>预约人及同行人核酸检测证明</span>
          <span
            v-if="
              !(
                data.visitorHealthCertificate &&
                data.visitorHealthCertificate.some((x) => x.type == 2)
              )
            "
          >
            : 暂无</span
          >
        </div>
        <div
          class="panel_1"
          v-if="
            data.visitorHealthCertificate &&
            data.visitorHealthCertificate.some((x) => x.type == 2)
          "
        >
          <img
            class="img_1"
            @click="previewImg(img.imgUrl)"
            v-for="img in data.visitorHealthCertificate.filter(
              (x) => x.type == 2
            )"
            :key="img.imgUrl"
            :src="img.imgUrl"
            alt=""
          />
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无数据" />
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      detail: "",
      yuTime: "",
      nucleStatus: false,
      data: null,
      txList: [
        {
          icon: "https://img95.699pic.com/photo/50138/5869.jpg_wh300.jpg",
          name: "吕小布",
          phone: "186452368111",
        },
        {
          icon: "https://img95.699pic.com/photo/50138/5869.jpg_wh300.jpg",
          name: "吕小布",
          phone: "186452368111",
        },
        {
          icon: "https://img95.699pic.com/photo/50138/5869.jpg_wh300.jpg",
          name: "吕小布",
          phone: "186452368111",
        },
      ],
    };
  },
  mounted() {
    this.getSubDetail();
    this.getSysSchool();
    this.searchContent();
  },
  methods: {
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },
    getMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getVisitorMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            this.$set(this.detail, 'noMobile', res.data)
            this.$set(this.detail, 'isShowMobile', !bol)

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        this.$set(this.detail, 'isShowMobile', !bol)

      }
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getFollowMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol

      }
    },
    // 判断是否显示核酸检测区域
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: localStorage.getItem("schoolId"),
        // schoolId:"1070770900580810752"
      });
      if (code !== 200) {
        // this.$toast('')
        return;
      }
      // 核酸模块是否必填
      this.nucleStatus = data.some((item) => item.functionDictCode == 29);
    },
    // 获取核酸相关图片
    async getSubDetail() {
      const { data, code } = await this.$https.getNoTokenDetail({
        visitorId: this.$route.query.id,
      });
      if (code !== 200) {
        this.$toast("获取详情失败");
        return false;
      }
      data.isShowMobile = false
      this.data = data;
      // 审批数据时间和人名转化
      this.data.busAuditLevelList.forEach((item) => {
        let obj = this.deptPersonList.find(
          (person) => person.id == item.designatedPersonId
        );
        item.name = obj.name;
        item.createdTime = moment(item.createdTime).format("YYYY-MM-DD HH:mm");
      });
    },

    //我是查出的内容
    async searchContent() {
      const { code, data } = await this.$https.visitorDetail({
        visitorId: this.$route.query.id,
      });
      if (code === 200) {
        console.log("我是查出的内容");
        console.log(data);
        data.personnelMessage.forEach(item => {
          item.isShowMobile = false
        })
        this.detail = data;
        console.log(
          moment(this.detail.visitorStartTime).format("YYYY-MM-DD HH:mm:ss")
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.visitorDetail {
  height: 100%;
  padding: 0.625rem 1rem;
  background: #f7f7fa;
  .box {
    margin-bottom: 1.25rem;
    padding: 1rem;
    background: #ffffff;
    box-shadow: 0rem 0.25rem 1rem rgba(69, 91, 99, 0.1);
    border-radius: 0.9375rem;
    .content {
      margin-top: 1rem;
      > div {
        padding-bottom: 0.6875rem;
        margin-bottom: 0.6875rem;
        border-bottom: 0.0625rem solid #f4f4f6;
        .sonTitle {
          color: #c4c4c4;
          height: 1rem;
          font-size: 0.75rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1rem;
          color: #c4c4c4;
          opacity: 1;
        }
        .value {
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.1875rem;
          color: #454f63;
          opacity: 1;
        }
        .status {
          width: 2.875rem;
          height: 1.3125rem;
          border: 0.0625rem solid #07c160;
          opacity: 1;
          font-size: 12px;

          border-radius: 0.25rem;
          color: #07c160;
        }
        .status.other {
          border: 0.0625rem solid #3497fd;
          color: #3497fd;
        }
        .status.error {
          border: 0.0625rem solid #f51a1a;
          color: #f51a1a;
        }
      }
      .icon {
        width: 4.125rem;
        height: 4.125rem;
        border-radius: 0.3125rem;
        margin-right: 0.75rem;
        img {
          width: 4.125rem;
          height: 4.125rem;
          border-radius: 0.3125rem;
        }
      }
      .rightContent {
        div:nth-of-type(1) {
          height: 1.625rem;
          font-size: 1.25rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.625rem;
          color: #1a1a1a;
          margin-bottom: 0.625rem;
        }
        div {
          height: 1.1875rem;
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.375rem;
          color: #666666;
        }
      }
      .smallBox {
        .imgBox {
          margin-right: 0.625rem;
          width: 3rem;
          height: 3rem;
          background: rgba(0, 0, 0, 0);
          border-radius: 0.25rem;
          img {
            width: 3rem;
            height: 3rem;
            border-radius: 0.25rem;
          }
        }
        .right {
          > div:nth-of-type(1) {
            height: 1.1875rem;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 1.1875rem;
            color: #2a2e43;
            margin-bottom: 0.375rem;
          }
          > div:nth-of-type(2) {
            height: 1.0625rem;
            font-size: 0.75rem;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 1.0625rem;
            color: #78849e;
          }
        }
      }
    }
  }
  .card {
    box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
    background: #fff;
    padding-bottom: 1rem;
    margin-bottom: 1.25rem;
    border-radius: 0.75rem;
    .title {
      color: #1a1a1a;
      font-size: 0.75rem;
      padding: 1rem 1.25rem;
    }

    .panel_1 {
      /* display: flex; */
      /* padding: 0rem 1rem 1rem 1rem; */
      margin: 0 1rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid rgba(244, 244, 246, 0.99);
      /* align-items: center; */
      .img {
        width: 4.125rem;
        height: 4.125rem;
        border-radius: 50%;
        margin-right: 0.75rem;
        object-fit: cover;
      }
      .img_1 {
        width: 4rem;
        height: 4rem;
        border-radius: 0.5rem;
        margin-right: 0.75rem;
        object-fit: cover;
      }
      .info {
        flex: 1;
        .name {
          color: #454f63;
          font-size: 1.5rem;
          font-weight: bold;
        }
        .phone {
          color: #cad1e2;
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }
      }
      .or {
        margin: 0.5rem 0;
        color: #78849e;
      }
      .center {
        text-align: center;
      }
      .time {
        font-size: 1rem;
        color: #78849e;
      }
    }
  }
  .title {
    height: 1rem;
    font-size: 0.75rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 1rem;
    color: #1a1a1a;
    opacity: 1;
  }
}
</style>




